@if (layer(); as currentLayer) {
  <div class="feature-layer-details">
    <div class="details-header">
      <mat-select
        class="layer-switcher"
        [value]="layerKey()"
        (selectionChange)="onLayerSelected($event)"
      >
        @for (option of layers(); track option.key) {
          <mat-option [value]="option.key">{{ option.label }}</mat-option>
        }
      </mat-select>
    </div>

    <div class="details-section">
      <h4 class="section-title">Symbology</h4>
      <div class="details-legend">
        @switch (legendState()) {
          @case ('loading') {
            <p class="legend-hint">Loading legend…</p>
          }
          @case ('error') {
            <p class="legend-hint">Legend unavailable.</p>
          }
          @case ('unavailable') {
            <p class="legend-hint">This layer has no legend.</p>
          }
          @case ('ready') {
            @for (entry of legendEntries(); track $index) {
              <div class="legend-entry">
                @if (entry.src; as src) {
                  <img
                    class="legend-swatch"
                    [src]="src"
                    [width]="entry.width ?? 20"
                    [height]="entry.height ?? 20"
                    alt=""
                  />
                }
                @if (entry.label) {
                  <span class="legend-label" [title]="entry.label">{{ entry.label }}</span>
                }
              </div>
            }
          }
        }
      </div>
    </div>

    <div class="details-section">
      <h4 class="section-title">Transparency</h4>
      <div class="transparency-slider-wrap">
        @if (sliderActive()) {
          <span class="thumb-bubble" [style.left.%]="bubbleLeft()">{{ transparency() }}%</span>
        }
        <mat-slider
          class="transparency-slider"
          min="0"
          max="100"
          step="1"
          [disabled]="!currentLayer.checked"
          (pointerdown)="sliderActive.set(true)"
        >
          <input
            matSliderThumb
            [ngModel]="transparency()"
            (ngModelChange)="onTransparencyChange($event)"
            (focus)="sliderActive.set(true)"
            (blur)="sliderActive.set(false)"
          />
        </mat-slider>
        <div class="slider-scale">
          @for (mark of sliderMarks; track mark) {
            <span class="slider-scale-mark">
              <span class="slider-scale-tick"></span>
              <span class="slider-scale-label">{{ mark }}%</span>
            </span>
          }
        </div>
      </div>
    </div>

    <div class="details-section">
      <h4 class="section-title">Actions</h4>
      <div class="details-actions">
        <button
          type="button"
          class="details-action details-focus"
          matTooltip="Focus"
          matTooltipPosition="below"
          (click)="focus()"
        >
          <mat-icon>gps_fixed</mat-icon>
        </button>
        <button
          type="button"
          class="details-action details-remove"
          matTooltip="Remove"
          matTooltipPosition="below"
          (click)="remove()"
        >
          <mat-icon>delete_outline</mat-icon>
        </button>
      </div>
    </div>
  </div>
}
